class FilterController {
    static openFilter() {
        $('#CollectionSidebar').removeAttr('hidden');
        $('#CollectionSidebar').addClass('is-active');
        $('#CollectionSidebarOverlay').addClass('overlay-opens');
        trapFocus($('#CollectionSidebar')[0]);
    }

    static closeFilter() {
        $('#CollectionSidebar').removeClass('is-active');
        $('#CollectionSidebarOverlay').removeClass('overlay-opens');
        $('#collectionFilterToggle').focus();

        setTimeout(() => {
            $('#CollectionSidebar').attr('hidden', 'hidden');
        }, 600);
    }

    static toggleFilter() {
        const direction = $('#CollectionSidebar').hasClass('is-active');
        if (!direction) {
            this.openFilter()
        } else {
            this.closeFilter()
        }
    }
}

$(window).on('keyup', function (event) {
    if (event.key === "Escape" || event.keyCode === 27) {
        FilterController.closeFilter();
    }
})

$(document).on('click', '#collectionFilterToggle', function (event) {
    event.preventDefault();
    FilterController.toggleFilter()
})

$(document).on('click', '#CollectionSidebarOverlay', function (event) {
    event.preventDefault();
    FilterController.toggleFilter();
});

$(document).on('click', '#collectionFilterDone', function (event) {
    event.preventDefault();
    FilterController.toggleFilter();
});

$(document).on('click', '#collectionSortToggle', function (event) {
    event.preventDefault();
    const direction = $('#collectionSort').toggleClass('is-active').hasClass('is-active');
    $(this).attr('aria-expanded', direction)
    $('#collectionSort').attr('aria-hidden', !direction)

    if (direction)
        trapFocus($('#collectionSort')[0])
})

$(document).click(function (event) {
    if (!$(event.target).closest("#collectionSort").length && !$(event.target).closest("#collectionSortToggle").length) {
        $("#collectionSort").removeClass('is-active');
        $("#collectionSort").attr('aria-hidden', true);
        $("#collectionSortToggle").attr('aria-expanded', false);
    }
});

document.addEventListener('DOMContentLoaded', function () {

    const clearAllLink = document.querySelector('.clear-all__filter');

    function updateClearAllVisibility() {

        const checkboxes = document.querySelectorAll('.filter-form .tag__input');
        const isAnyCheckboxChecked = Array.from(checkboxes).some(checkbox => checkbox.checked);
        const hasFilterParams = window.location.search.includes('filter.v.');

        clearAllLink.style.display = (isAnyCheckboxChecked || hasFilterParams) ? 'block' : 'none';
    }

    const filterCheckboxes = document.querySelectorAll('.filter-form .tag__input');
    filterCheckboxes.forEach(function (checkbox) {
        checkbox.addEventListener('change', updateClearAllVisibility);
    });

    updateClearAllVisibility();
});
